import moment from 'moment-timezone'

const filterDataHora = (date) => {
    if (date) {
        return moment(date)
            .format('DD/MM/YYYY HH:mm')
    }
    return '----'
}

export default filterDataHora